import styled from "styled-components";

export const Container = styled.section`
  display: flex;
  width: 100%;

  .member-count-view span {
    font-size: 1.4rem;
  }
`;